<template>
  <div class="informedConsent">
    <van-nav-bar
      :title="title"
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="consentList">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="centerBg"
          v-for="(item, index) in list"
          :key="index"
          @click="toDetails(item)"
        >
          <p>{{ item.title }}{{ item.version }}</p>
          <span>{{ item.createTime }}</span>
        </div>
        <div class="noData" v-if="noDataStatus">
          <img
            class="_nodata_"
            src="@/assets/images/test-center/no-data.png"
            alt=""
          />
          <p class="_nodatap_">现在还没有数据哦！</p>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { _contentPage, _contentId } from "../../api/setting";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { decryptBy } from "@/assets/js/encryption";
export default {
  name: "informed-consent",
  data() {
    return {
      currentPage: 1, // 当前页 不能小于1
      loading: true, //加载
      finished: false, // 结束加载
      noDataStatus: false, //暂无数据状态
      phone: "",
      list: [],
      title: "隐私政策",
    };
  },
  created() {
    let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    this.phone = decryptBy(user.mobilePhoneStr);
    this.contentPage();
  },
  mounted() {
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    // 滑动加载
    onLoad() {
      this.currentPage++;
      this.contentPage();
    },
    // 获取知情同意书列表
    contentPage() {
      _contentPage({
        asc: false,
        currentPage: this.currentPage,
        pageSize: 10,
        orderByField: "",
        queryData: {
          contentType: 2,
          modelType: 1,
          phone: this.phone,
        },
      }).then((res) => {
        if (res && res.code == 200) {
          let rows = res.data.records; //请求返回当页的列表
          this.loading = false;
          if (rows.length < 20) {
            // 加载结束
            this.finished = true;
          }
          // 将新数据与老数据进行合并
          if (this.currentPage == 1) {
            this.list = rows;
          } else {
            this.list = [...this.list, ...rows];
          }
          if (this.list.length > 0) {
            this.noDataStatus = false;
          } else {
            this.noDataStatus = true;
          }
        } else {
          this.finished = true;
          this.$toast(res.message);
        }
      });
    },
    // 跳转详情页
    toDetails(item) {
      this.$router.push({
        path: "/informedConsentDetail",
        query: {
          id: item.id,
          version: item.version,
          signImg: item.signImg,
          title: this.title,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-nav {
  position: fixed;
  width: 100%;
  top: 0;
}
.consentList {
  width: 100%;
  padding: 50px 15px 0;
  .centerBg {
    width: 345px;
    height: 64px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(208, 208, 208, 0.5);
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    line-height: 64px;
    margin: 10px 0;
  }
}
.noData {
  padding: 30px;
  text-align: center;
}
</style>
